import React from 'react';
import { IconContext } from "react-icons";
import { FaInfo } from 'react-icons/fa';
import { FaRegCheckCircle } from 'react-icons/fa';

import AssignmentLink from './AssignmentLink';

require('../../css/components/AssignmentSlat.scss');

'use strict';

export default class AssignmentSlat extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var assignment = this.props.assignment;
        var assignmentComplete = assignment && assignment.displayAsComplete;

        var msgKey = "msg-" + this.props.parentKey;
        var copy = this.props.copy;

        return (
            <div className={"assignmentSlat" + (this.props.className ? " " + this.props.className : "")}>

                <div className="d-flex flex-row align-items-center assignmentSlat__title">
                    <div>
                        {
                            this.props.url ?
                                <h3><AssignmentLink assignment={assignment} url={this.props.url} urlHash={this.props.urlHash} languageCode={this.props.languageCode} /></h3> :
                                <h3>{assignment.titleDx[this.props.languageCode]}</h3>
                        }
                    </div>
                    <div>
                        {
                            this.props.url ?
                                <h3><AssignmentLink className="titleCount" title={"(" + assignment.items.length + " " + (assignment.items.length === 1 ? copy.title : copy.titles) + ")"} assignment={assignment} url={this.props.url} urlHash={this.props.urlHash} /></h3> :
                                null
                        }
                    </div>
                    <div>
                        {
                            !assignment ?
                                null :
                                <div className="d-flex flex-column justify-content-center">
                                    {
                                        assignmentComplete ?
                                            <a className="btn collapsed" data-toggle="collapse" data-target={"#" + msgKey} aria-controls={msgKey} aria-expanded={false} title={copy.completedTooltip} >
                                                <IconContext.Provider value={{ className: "icon" }}>
                                                    <FaRegCheckCircle color="#009E0F" />
                                                </IconContext.Provider>
                                            </a> :
                                            assignment.progress >= 1.0 ?
                                                <a className="btn collapsed" data-toggle="collapse" data-target={"#" + msgKey} aria-controls={msgKey} aria-expanded={false} title={copy.actionRequiredTooltip} >
                                                    <IconContext.Provider value={{ className: "icon" }}>
                                                        <FaInfo color="#DB8008" />
                                                    </IconContext.Provider>
                                                </a> :
                                                null
                                    }
                                </div>
                        }
                </div>
            </div>
            {
                !assignment ?
                    null :
                    assignmentComplete ?
                        <div id={msgKey} className="collapse">
                            <div className="msg" style={{ color: "#009E0F" }}>
                                {copy.completedMessage}
                            </div>
                        </div> :
                        assignment.progress >= 1.0 ?
                            <div id={msgKey} className="collapse">
                                <div className="msg" style={{ color: "#DB8008" }}>
                                    {copy.actionRequiredMessage}
                                </div>
                            </div> :
                            null
            }
        </div>
        );
    }
}